import React from 'react';
import { Helmet } from 'react-helmet';
interface SEOProps {
  title: string;
  description: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: 'website' | 'article';
  structuredData?: object;
}
const SEO = ({
  title,
  description,
  canonicalUrl,
  ogImage = 'https://uploadthingy.s3.us-west-1.amazonaws.com/6enBba7nGTipGJpvGovp6X/IMG_1828.jpg',
  ogType = 'website',
  structuredData
}: SEOProps) => {
  const siteUrl = 'https://legacylabfinancial.com';
  const fullTitle = `${title} | Legacy Lab Financial`;
  return <Helmet data-id="element-440">
      <title data-id="element-441">{fullTitle}</title>
      <meta name="description" content={description} data-id="element-442" />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} data-id="element-443" />}
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} data-id="element-444" />
      <meta property="og:title" content={fullTitle} data-id="element-445" />
      <meta property="og:description" content={description} data-id="element-446" />
      <meta property="og:image" content={ogImage} data-id="element-447" />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" data-id="element-448" />
      <meta name="twitter:title" content={fullTitle} data-id="element-449" />
      <meta name="twitter:description" content={description} data-id="element-450" />
      <meta name="twitter:image" content={ogImage} data-id="element-451" />
      {/* Structured Data */}
      {structuredData && <script type="application/ld+json" data-id="element-452">
          {JSON.stringify(structuredData)}
        </script>}
    </Helmet>;
};
export default SEO;